import { cn } from '@sohanemon/utils';
import { formatPercent } from '@sohanscript/lib/utils/format';
import { useSohanEmon } from '#/lib/hooks/sohanemon.tsx';

type ResumeSkillsProps = React.ComponentProps<'div'>;

export function ResumeSkills({ className, ...props }: ResumeSkillsProps) {
	const { skills } = useSohanEmon();

	return (
		<div className={cn('space-y-2.5', className)} {...props}>
			{skills.map((s) => (
				<div key={s.name}>
					<div className="mb-1 flex items-center justify-between">
						<span className="font-mono text-2xs text-foreground">{s.name}</span>
						<span className="font-mono text-3xs text-muted-foreground">
							{formatPercent(s.level)}
						</span>
					</div>
					<div className="h-0.5 overflow-hidden rounded-full bg-muted">
						<div
							className="h-full rounded-full bg-primary"
							style={{ width: `${s.level}%` }}
						/>
					</div>
				</div>
			))}
		</div>
	);
}
